import { Component, OnInit } from '@angular/core';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { ActivatedRoute } from '../../../node_modules/@angular/router';

@Component({
  selector: 'app-employee-qrcode-list',
  templateUrl: './employee-qrcode-list.component.html',
  styleUrls: ['./employee-qrcode-list.component.css']
})
export class EmployeeQrcodeListComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.EMPLOYEEQRCODE, locator, route);
  }

  populateForm(form, data) {
    form.empId = data.empId;
    form.empName = data.empName;
    form.qrCode = data.qrCode;
    console.log('-------->', data);
  }

}
